module.exports = __webpack_public_path__ + "img/over_65s.256e58f4.webp";